import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onScheduleConsultation: () => void;
}

const CTASection = ({ onScheduleConsultation }: CTASectionProps) => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-primary/95 to-secondary text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-72 h-72 bg-success rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center space-x-2 bg-accent/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <Icon name="BoltIcon" size={20} className="text-accent" />
          <span className="text-sm font-semibold">Ready to Transform Your Marketing?</span>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-6">
          Start Your Marketing Automation Journey Today
        </h2>

        <p className="text-lg text-primary-foreground/90 mb-8 max-w-2xl mx-auto leading-relaxed">
          Schedule a free consultation with our AI strategy experts. We'll analyze your current marketing operations and show you exactly how automation can drive measurable growth.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <button
            onClick={onScheduleConsultation}
            className="px-8 py-4 bg-accent text-accent-foreground font-heading font-semibold rounded-lg hover:bg-accent/90 hover:shadow-elevated transition-all duration-300 transform hover:-translate-y-0.5 flex items-center justify-center space-x-2"
          >
            <Icon name="CalendarIcon" size={20} />
            <span>Schedule Free Consultation</span>
          </button>

          <a
            href="https://hlygziqktowemwmpjwgx.supabase.co/storage/v1/object/public/rlx-resources/RLX%20-%20Marketing%20Strategy.pdf"
            download="RLX-Marketing-Strategy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-primary-foreground/10 backdrop-blur-sm text-primary-foreground font-heading font-semibold rounded-lg hover:bg-primary-foreground/20 transition-all duration-300 flex items-center justify-center space-x-2"
          >
            <Icon name="DocumentTextIcon" size={20} />
            <span>Download Strategy Guide</span>
          </a>
        </div>

        <div className="grid sm:grid-cols-3 gap-8 pt-8 border-t border-primary-foreground/20">
          <div className="text-center">
            <div className="w-16 h-16 bg-success/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="ClockIcon" size={28} className="text-success" />
            </div>
            <p className="text-2xl font-heading font-bold mb-1">30 Minutes</p>
            <p className="text-sm text-primary-foreground/80">Free Strategy Session</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-accent/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="DocumentChartBarIcon" size={28} className="text-accent" />
            </div>
            <p className="text-2xl font-heading font-bold mb-1">Custom Plan</p>
            <p className="text-sm text-primary-foreground/80">Tailored to Your Needs</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-primary/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="ShieldCheckIcon" size={28} className="text-primary-foreground" />
            </div>
            <p className="text-2xl font-heading font-bold mb-1">No Obligation</p>
            <p className="text-sm text-primary-foreground/80">Zero Pressure Approach</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;